export default __webpack_public_path__ + "static/media/arshiyan.5cc19001.svg";